const n = n => "signIn" === n || "signUp" === n;
export { n as isSignInOrSignUpRoute };